import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGoogleMapsKey } from "../../../actions/configuration";

const positiveArtId = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const useGoogleMapsApiKey = (idArt) => {
  const artId = positiveArtId(idArt);
  const artKey = artId ? String(artId) : "";
  const dispatch = useDispatch();
  const sawFetchingRef = useRef(false);
  const entry = useSelector((state) =>
    artKey ? state.configuration.googleMapsKeys?.[artKey] : null,
  );
  const hasStoredKey = typeof entry?.data === "string";

  const entryRef = useRef(entry);
  entryRef.current = entry;
  if (entry?.isFetching) sawFetchingRef.current = true;

  useEffect(() => {
    const current = entryRef.current;
    if (!artKey || typeof current?.data === "string" || current?.isFetching) return;
    dispatch(getGoogleMapsKey(artKey));
  }, [artKey, dispatch]);

  const failed =
    sawFetchingRef.current &&
    entry?.data === null &&
    !entry?.isFetching;

  return {
    apiKey: artId ? (hasStoredKey ? entry.data : "") : CONFIG.googleMapsKey || "",
    isFetching: Boolean(artId) && !hasStoredKey && !failed,
    failed,
  };
};
